// extracted by mini-css-extract-plugin
export default {"itemsContainer":"oWT1n5sAvnbQGr_gEGVm"};